import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';

export default function AddCategoryToMultipleBusinesses() {
  const [businesses, setBusinesses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedBusinessIds, setSelectedBusinessIds] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    const loadData = async () => {
      const bSnap = await getDocs(collection(db, 'businesses'));
      const cSnap = await getDocs(collection(db, 'categories'));

      const bList = bSnap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(b => !!b.business_name)
        .sort((a, b) => a.business_name.localeCompare(b.business_name));
      const cList = cSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setBusinesses(bList);
      setCategories(cList);
    };

    loadData();
  }, []);

  const handleCheckboxChange = (id) => {
    setSelectedBusinessIds(prev =>
      prev.includes(id)
        ? prev.filter(bid => bid !== id)
        : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    if (!selectedCategoryId || selectedBusinessIds.length === 0) {
      setStatus('❌ Please select at least one business and a category.');
      return;
    }

    let updatedCount = 0;

    for (const bid of selectedBusinessIds) {
      const bRef = doc(db, 'businesses', bid);
      const business = businesses.find(b => b.id === bid);
      const current = business.categoryIds || [];

      if (!current.includes(selectedCategoryId)) {
        const updated = [...current, selectedCategoryId];
        await updateDoc(bRef, { categoryIds: updated });
        updatedCount++;
      }
    }

    setStatus(`✅ Category applied to ${updatedCount} of ${selectedBusinessIds.length} selected businesses.`);
  };

  return (
    <div style={{ padding: '30px', fontFamily: 'Arial' }}>
      <h2>Add Category to Multiple Businesses</h2>

      <div style={{ marginBottom: '30px' }}>
        <strong>Select Businesses:</strong>
        <div style={{ maxHeight: '300px', overflowY: 'scroll', border: '1px solid #ccc', padding: '10px' }}>
          {businesses.map(b => (
            <div key={b.id}>
              <label>
                <input
                  type="checkbox"
                  value={b.id}
                  checked={selectedBusinessIds.includes(b.id)}
                  onChange={() => handleCheckboxChange(b.id)}
                />
                {' '}
                {b.business_name}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <strong>Select Category:</strong><br />
        <select
          value={selectedCategoryId}
          onChange={e => setSelectedCategoryId(e.target.value)}
          style={{ padding: '8px', width: '300px' }}
        >
          <option value="">-- Choose a category --</option>
          {categories.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      <button
        onClick={handleSubmit}
        style={{
          padding: '10px 20px',
          fontWeight: 'bold',
          backgroundColor: '#234f72',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          borderRadius: '5px'
        }}
      >
        Add Category to Selected
      </button>

      {status && (
        <div style={{ marginTop: '20px', fontSize: '16px' }}>{status}</div>
      )}
    </div>
  );
}
